import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DivisionDefaultForm } from '../forms/DivisionDefaultForm';

type DivisionDefaultModalProps = {
  divisionUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const DivisionDefaultModal = ({ divisionUuid, isOpen, onClose }: DivisionDefaultModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      title={divisionUuid ? t('divisions.editDefault') : t('divisions.addDefault')}
      isOpen={isOpen}
      loading={loading}
      onRequestClose={() => onClose()}
    >
      <DivisionDefaultForm
        divisionUuid={divisionUuid}
        onClose={() => onClose()}
        onLoad={(loading) => setLoading(loading)}
      />
    </Modal>
  );
};
